module.exports = __webpack_public_path__ + "html/political-landing_32672f94e4f7484f88b70608ca525d8a.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/political-landing.html
// module id = kvRk
// module chunks = 154